import { transport } from 'config/transport';

export function callApiGetThuChiCTPV(congDoanId, yearMonth, type) {
    return transport.get(`/ctpv/thuchi/congDoan/${congDoanId}`, { params: { yearMonth, type } });
}
